import {automationSvg as Icon__small__automationSvg} from '../Icon__small/Icon__small--automation.js';

export var automation = {
  name: 'automation',
  category: 'icon',
  colorable: true,
  svg: Icon__small__automationSvg,
};
